import { User } from 'interfaces/user';

const NOT_LOGGED_USER = 'User is not logged in';
const RYAN_RTS_DOMAIN = '@ryanrts.com';
const SHAMROCK_DOMAIN = '@shamrocktradingcorp.com';

export const getUserId = (user: User): string => (!user ? NOT_LOGGED_USER : user._id);
export const isInternalUser = (user: User): boolean => user?.email?.endsWith(RYAN_RTS_DOMAIN || SHAMROCK_DOMAIN);
export const hasFuelPermission = (permissions: any): boolean => permissions?.includes('fuel.User');
export const hasFreightPermission = (permissions: any): boolean => permissions?.includes('ryantrans.Loadboard');
export const hasCreditPermission = (permissions: any): boolean => permissions?.includes('credit.User');
export const hasFactoringPermission = (permissions: any): boolean => permissions?.includes('invoicemanager.User');
export const hasLoadManagementPermission = (permissions: any): boolean => permissions?.includes('loadManagement.User');
export const hasTripManagementPermission = (permissions: any): boolean => permissions?.includes('trial.User');
export const hasProTransportBasicPermission = (permissions: any): boolean => permissions?.includes('tms.user.basic');
export const hasProTransportPremiumPermission = (permissions: any): boolean =>
  permissions?.includes('ProTransportWeb.user') || permissions?.includes('tms.user.premium');
export const hasBankingPermission = (permissions: any): boolean => permissions?.includes('banking.User');
